abstract class MemoryTarget {

  static readonly key: string;

  abstract get key(): string;
  abstract toJSON(): object;

}

export { MemoryTarget };